import BoldText from '@/components/BoldText';
import RegularText from '@/components/RegularText';
import { openCrisp } from '@/helpers';
import { THUMBNAIL } from '@/helpers/link';
import { BlockStack, Box, Button, Card, Collapsible, InlineStack, useBreakpoints } from '@shopify/polaris';
import { XIcon } from '@shopify/polaris-icons';
import { useState } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const CustomizeDesignBanner = ({ isOpen, onClose }: Props) => {
  const [dismissed, setDismissed] = useState(isOpen);
  return (
    <Collapsible id={'cta-widget-banner'} open={dismissed}>
      <Card padding={'0'}>
        <Box paddingBlock={'100'} paddingInlineStart={'500'} paddingInlineEnd={'800'} position="relative">
          <Box position="absolute" insetBlockStart="0" insetInlineEnd="0" padding={'200'}>
            <Button
              icon={XIcon}
              variant="tertiary"
              onClick={() => {
                onClose();
                setDismissed(false);
              }}
            />
          </Box>
          <InlineStack
            blockAlign="center"
            align={useBreakpoints().mdUp ? 'space-between' : 'center'}
            wrap={useBreakpoints().mdDown}
          >
            <BlockStack align="start" inlineAlign="start" gap={'400'}>
              <BoldText>Personalize your widget!</BoldText>
              <RegularText>
                Want the app to match your store’s look and feel? Share your customization requests, and our experts will tailor
                it to fit your theme perfectly—at no cost!
              </RegularText>
              <Button onClick={openCrisp}>Contact us now – It’s free</Button>
            </BlockStack>
            <div style={{ width: '160px', height: '160px' }}>
              <img
                src={THUMBNAIL.WIDGET_APPEARANCE_CTA_IMG}
                alt=""
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </div>
          </InlineStack>
        </Box>
      </Card>
    </Collapsible>
  );
};

export default CustomizeDesignBanner;
